/**
 * MCP tools for credential management.
 *
 * Mirrors `canary credential list`.
 *
 * @module
 */

import { mcpApiRequest } from '../api-client';
import { toolJson } from '../tool-helpers';

export function getCredentialToolDefinitions() {
  return [
    {
      name: 'canary_credential_list',
      description:
        'List credentials in the current organization with their property and environment info.',
      inputSchema: {
        type: 'object',
        properties: {
          property: {
            type: 'string',
            description: 'Filter by property name or ID',
          },
        },
      },
    },
  ];
}

export async function handleCredentialTool(
  tool: string,
  args: Record<string, unknown>
) {
  if (tool === 'canary_credential_list') {
    try {
      const result = await mcpApiRequest<{
        ok: boolean;
        items: Array<{
          id: string;
          name: string;
          propertyId: string;
          propertyName?: string;
          propertyBaseUrl?: string;
          environmentId?: string | null;
          environmentName?: string | null;
          isEphemeral?: boolean;
        }>;
      }>('GET', '/org/credentials');

      let items = result.items ?? [];

      // Filter out ephemeral credentials
      items = items.filter((c) => !c.isEphemeral);

      // Apply property filter if provided
      if (args.property) {
        const filter = String(args.property).toLowerCase();
        items = items.filter(
          (c) =>
            c.propertyId === args.property ||
            (c.propertyName && c.propertyName.toLowerCase().includes(filter))
        );
      }

      return toolJson({ ok: true, credentials: items });
    } catch (err) {
      return toolJson({ ok: false, error: err instanceof Error ? err.message : String(err) });
    }
  }

  return null;
}
